"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookFieldsQueryGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var WorkbookFieldsWithInheritanceByIdQueryGql_1 = require("../../queries/WorkbookFieldsWithInheritanceByIdQueryGql");
var FieldFunctions_1 = require("../field/functions/FieldFunctions");
var WorkbookFieldsDisplayGrid_1 = require("./WorkbookFieldsDisplayGrid");
function selectConnectionListResultOld(resultData) {
    return resultData && resultData.workbooks && resultData.workbooks[0] &&
        resultData.workbooks[0].embeddedDatasources[0] && resultData.workbooks[0].embeddedDatasources[0].fieldsConnection;
}
function mapResultNodeOld(field, resultData) {
    return __assign(__assign({}, field), { dataType: field.dataType || null, workbookId: resultData.workbooks[0].vizportalUrlId, fieldIcon: FieldFunctions_1.iconForField(field), sheetCount: field.downstreamSheetsConnection ? field.downstreamSheetsConnection.totalCount : null });
}
function selectConnectionListResult(resultData) {
    return resultData && resultData.workbooks && resultData.workbooks[0] &&
        resultData.workbooks[0].embeddedDatasources[0] && resultData.workbooks[0].embeddedDatasources[0].fieldsConnection;
}
function mapResultNode(field, resultData) {
    return __assign(__assign({}, field), { dataType: field.dataType || null, workbookId: resultData.workbooks[0].vizportalUrlId, fieldIcon: FieldFunctions_1.iconForField(field), sheetCount: field.downstreamSheetsConnection ? field.downstreamSheetsConnection.totalCount : null, dataQualityWarnings: extractWarnings(field) });
}
function WorkbookFieldsQueryGrid(props) {
    var _a = React.useContext(data_catalog_shared_1.FeatureFlagsContext), columnDQWs = _a.columnDQWs, publishedConnectionsLineageEnabled = _a.publishedConnectionsLineageEnabled;
    if (!columnDQWs) {
        return (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: WorkbookFieldsWithInheritanceByIdQueryGql_1.WorkbookFieldsWithInheritanceByIdQueryGql, partialQueryVariables: {
                workbookVizportalUrlId: props.vizportalUrlId,
                selectedEmbeddedDatasourceId: props.selectedEmbeddedDatasourceId,
                orderBy: props.orderBy,
            }, selectConnectionListResult: selectConnectionListResultOld, mapResultNode: mapResultNodeOld }, function (_a) {
            var rowStore = _a.rowStore;
            return (React.createElement(WorkbookFieldsDisplayGrid_1.WorkbookFieldsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
        }));
    }
    return (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: WorkbookFieldsWithInheritanceByIdQueryGql_1.WorkbookFieldsWithInheritanceAndWarningsByIdQueryGql, partialQueryVariables: {
            workbookVizportalUrlId: props.vizportalUrlId,
            selectedEmbeddedDatasourceId: props.selectedEmbeddedDatasourceId,
            orderBy: props.orderBy,
            columnDQWs: columnDQWs,
            publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, function (_a) {
        var rowStore = _a.rowStore;
        return (React.createElement(WorkbookFieldsDisplayGrid_1.WorkbookFieldsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
    }));
}
exports.WorkbookFieldsQueryGrid = WorkbookFieldsQueryGrid;
function extractWarnings(field) {
    var _a;
    if (field.__typename !== 'ColumnField') {
        return undefined;
    }
    var result = [];
    (_a = field.columnsConnection) === null || _a === void 0 ? void 0 : _a.nodes.forEach(function (c) { return result.push.apply(result, c.dataQualityWarnings); });
    return result;
}
//# sourceMappingURL=WorkbookFieldsQueryGrid.js.map